<div class="flex w-full flex-col items-center justify-center gap-4 px-4 py-2">
  <div class="flex w-full items-center justify-between px-2">
    <div class="flex items-center gap-4">
      <h2 class="textTabsColor text-xl font-bold" i18n="@@todaysOffers">Today's Offers</h2>
      <a routerLink="/user/offers" class="textTabsColor pt-1 text-sm font-medium hover:underline" i18n="@@vAllOffers">
        View All
      </a>
    </div>
  </div>

  @if (loading()) {
    <div class="relative aspect-[21/5] w-full max-w-[1500px] animate-pulse overflow-hidden rounded-2xl bg-gray-200">
      <div class="flex h-full w-full items-center justify-center">
        <svg
          class="h-10 w-10 animate-spin text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
    </div>
  } @else if (offers().length === 0) {
    <div class="flex h-[150px] w-full items-center justify-center rounded-2xl border border-rose-100 bg-rose-50">
      <p class="font-['Inter'] text-sm text-gray-400">
        {{ isArabic() ? "لا توجد عروض متاحة" : "No Offers Available" }}
      </p>
    </div>
  } @else {
    <div class="relative w-full max-w-[1500px]">
      <div
        class="relative aspect-[21/5] w-full overflow-hidden rounded-2xl border border-gray-100 bg-gray-50 shadow-sm">
        <button
          (click)="nextSlide()"
          class="hover:bgTabsColor absolute top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-white/90 shadow-md transition-all hover:text-white focus:outline-none ltr:right-3 rtl:left-3">
          <svg class="h-4 w-4 fill-current rtl:rotate-180" viewBox="0 0 20 35">
            <path
              d="M0.298178 33.5V1.5C0.298178 0.2 1.7807 -0.6 2.8157 0.4L19.5347 16.4C20.155 17 20.155 18 19.5347 18.6L2.8157 34.6C1.7807 35.6 0.298178 34.8 0.298178 33.5Z" />
          </svg>
        </button>

        @if (currentOffer()) {
          <div
            (click)="navigateToDetails(currentOffer())"
            [@fadeAnimation]
            class="group relative h-full w-full cursor-pointer">
            @if (getImage(currentOffer())) {
              <img [src]="getImage(currentOffer())" [alt]="currentOffer().titleEn" class="h-full w-full object-cover" />
            } @else {
              <div class="flex h-full w-full items-center justify-center bg-gray-50">
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 48 48">
                  <g class="fill-border-input">
                    <path d="M37.084 15.735a1 1 0 1 0 .448-1.949l-6.616-1.52a1 1 0 1 0-.448 1.948z" />
                    <path
                      fill-rule="evenodd"
                      d="M34 22a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-2a6 6 0 1 0 0-12a6 6 0 0 0 0 12M16.778 9.245c-.647-1.532-2.813-1.686-3.682-.263L6.292 20.115c-.785 1.284.092 2.924 1.623 3.033l11.866.846c1.53.11 2.644-1.388 2.06-2.77zm-1.967.768l-.009.012L8.01 21.14l.002.002l.01.004a.1.1 0 0 0 .036.007l11.867.846h.038a.1.1 0 0 0 .029-.015l-5.056-11.96l-.004-.01a.1.1 0 0 0-.054-.014a.13.13 0 0 0-.062.009l-.003.001v.001zM35.385 36.36a6 6 0 0 0-5.071-10.876l-10.876 5.07a6 6 0 1 0 5.071 10.877zm-15.102-3.992a4 4 0 1 0 3.381 7.25l4.466-2.083l-3.38-7.25zm9.66 4.322l-3.381-7.25l4.597-2.144a4 4 0 1 1 3.38 7.25z"
                      clip-rule="evenodd" />
                  </g>
                </svg>
              </div>
            }
            <div class="absolute inset-0 bg-black/0 transition-colors duration-300 group-hover:bg-black/5"></div>
          </div>
        }

        <button
          (click)="previousSlide()"
          class="hover:bgTabsColor absolute top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-white/90 shadow-md transition-all hover:text-white focus:outline-none ltr:left-3 rtl:right-3">
          <svg class="h-4 w-4 fill-current rtl:rotate-180" viewBox="0 0 20 35">
            <path
              d="M19.7018 1.5V33.5C19.7018 34.8 18.2193 35.6 17.1843 34.6L0.465303 18.6C-0.155 18 -0.155 17 0.465303 16.4L17.1843 0.4C18.2193 -0.6 19.7018 0.2 19.7018 1.5Z" />
          </svg>
        </button>
      </div>

      <div class="absolute bottom-3 left-1/2 z-20 flex -translate-x-1/2 gap-1.5">
        @for (offer of offers(); track offer.id; let i = $index) {
          <button
            (click)="goToSlide(i)"
            [class]="i === currentSlide() ? 'bgTabsColor w-6' : 'w-1.5 bg-white/80'"
            class="h-1.5 cursor-pointer rounded-full shadow-sm transition-all duration-300"></button>
        }
      </div>
    </div>
  }
</div>
